var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00006 2.34345C9.56215 0.781351 12.0948 0.78135 13.6569 2.34345C15.219 3.90554 15.219 6.4382 13.6569 8.0003L12.7141 8.94311C12.4538 9.20346 12.0316 9.20346 11.7713 8.94311C11.5109 8.68276 11.5109 8.26065 11.7713 8.0003L12.7141 7.05749C13.7555 6.01609 13.7555 4.32765 12.7141 3.28626C11.6727 2.24486 9.98427 2.24486 8.94287 3.28626L8.00006 4.22907C7.73971 4.48942 7.3176 4.48942 7.05725 4.22907C6.7969 3.96872 6.7969 3.54661 7.05725 3.28626L8.00006 2.34345ZM10.8048 5.19555C11.0651 5.4559 11.0651 5.87801 10.8048 6.13836L6.13813 10.805C5.87778 11.0654 5.45567 11.0654 5.19532 10.805C4.93497 10.5447 4.93497 10.1226 5.19532 9.86222L9.86199 5.19555C10.1223 4.9352 10.5444 4.9352 10.8048 5.19555ZM4.22882 7.05749C4.48917 7.31784 4.48917 7.73995 4.22882 8.0003L3.28601 8.94311C2.24461 9.98451 2.24461 11.6729 3.28601 12.7143C4.32741 13.7557 6.01585 13.7557 7.05725 12.7143L8.00006 11.7715C8.26041 11.5112 8.68252 11.5112 8.94287 11.7715C9.20322 12.0319 9.20322 12.454 8.94287 12.7143L8.00006 13.6572C6.43796 15.2193 3.9053 15.2193 2.3432 13.6572C0.781106 12.0951 0.781107 9.5624 2.3432 8.0003L3.28601 7.05749C3.54636 6.79714 3.96847 6.79714 4.22882 7.05749Z",
    fill: "#017E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.eca83c5f6cbacfe40762b64f427cf828.svg";
export { ForwardRef as ReactComponent };